// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"862":"b86bc54b","1555":"68b02b65","5314":"e08f3d1c","8532":"e08f3d1c"}[chunkId] + ".chunk.css";
};